import styled from '@emotion/styled';

import { Badge } from '@/components/common/Badge';
import { HeadingLevel } from '@/components/common/MarkUp';
import { Title } from '@/components/common/Title';
import { Stack } from '@/components/layout/Stack';

import type { Heading } from '@/types/shared';

export interface DataChipsProps {
  heading?: Heading;
  badges?: Array<{ _key: string; _type: 'tag'; tagText?: string }>;
}

export const DataChips = ({ heading, badges }: DataChipsProps) => {
  return (
    <Stack spacing="--space-component-xl">
      {heading && (
        <HeadingLevel>
          <Title heading={heading} size="sm" variant="block" />
        </HeadingLevel>
      )}
      <BadgesWrapper>
        {badges?.map((badge) => (
          <Badge
            key={badge._key}
            bgColour={{
              _type: 'surfaceColour',
              value: 'rgb(237, 236, 232)',
              token: '--surface-warm-strong',
            }}
            margin="0"
          >
            {badge.tagText}
          </Badge>
        ))}
      </BadgesWrapper>
    </Stack>
  );
};

const BadgesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-component-md);
`;
